import React from "react";
import "./NoPermission.css";

const NoPermission = () => {
  return (
    <div className="np-container">
      <svg className="np-error-icon" xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none">
        <path d="M35.5003 65.0832C51.8388 65.0832 65.0837 51.8383 65.0837 35.4998C65.0837 19.1614 51.8388 5.9165 35.5003 5.9165C19.1619 5.9165 5.91699 19.1614 5.91699 35.4998C5.91699 51.8383 19.1619 65.0832 35.5003 65.0832Z" stroke="#BD3D44" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.5 23.6665V35.4998" stroke="#BD3D44" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.5 47.3335H35.53" stroke="#BD3D44" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <h1 className="np-error-title fts-22 ftw-6">You Do Not Have Access To This Page</h1>
      <p className="np-error-message fts-15 ftw-4 ">We're sorry, your account does not have permission to access this page.</p>
      {/* <button className="np-back-button" onClick={() => window.history.back()}>Go Back</button> */}
    </div>
  );
};

export default NoPermission;